import { getBreadcrumbs, getNestedPages } from '@pm2/api';
import { findPageDescriptorByPath } from './util.find-page-descriptor-by-path.js';
import { makeSearchPageDescriptor } from './util.make-search-page-descriptor.js';

async function fetchPageDescriptorByPath(configStore, sitemapStore, path) {
  const configState = configStore.getState();
  if (path === configState.config.searchPath) {
    return makeSearchPageDescriptor(path);
  }
  const breadcrumbs = await getBreadcrumbs(configState.config, path, {
    previewMode: configState.previewMode
  });
  if (breadcrumbs === void 0) {
    sitemapStore.dispatch(sitemapStore.actions.registerNotFoundPath(path));
    return void 0;
  }
  let subNavigationRoot;
  let parentLayer = sitemapStore.getState().rootDescriptors;
  for (const breadcrumb of breadcrumbs) {
    const parentPage = parentLayer == null ? void 0 : parentLayer.find((it) => it.id === breadcrumb);
    if (!parentPage) {
      throw new Error(
        "Store.fetchPageDescriptorByPath(...): Unable to look up breadcrumbs - this is most likely an API issue"
      );
    }
    if (!parentPage.children) {
      parentLayer = await getNestedPages(configState.config, parentPage.id, {
        previewMode: configState.previewMode
      });
      sitemapStore.dispatch(
        sitemapStore.actions.updatePageDescriptor({
          ...parentPage,
          children: parentLayer
        })
      );
    } else {
      parentLayer = parentPage.children;
    }
    if (parentPage.type === "Course") {
      subNavigationRoot = parentPage;
    }
  }
  subNavigationRoot = subNavigationRoot ?? parentLayer.find((it) => it.path === path);
  if (subNavigationRoot == null ? void 0 : subNavigationRoot.hasChildren) {
    const children = await getNestedPages(
      configState.config,
      subNavigationRoot.id,
      {
        levels: subNavigationRoot.type === "Course" ? 2 : 1,
        previewMode: configState.previewMode
      }
    );
    sitemapStore.dispatch(
      sitemapStore.actions.updatePageDescriptor({
        ...subNavigationRoot,
        children
      })
    );
  }
  return findPageDescriptorByPath(sitemapStore.getState(), path);
}

export { fetchPageDescriptorByPath };
//# sourceMappingURL=util.fetch-page-descriptor-by-path.js.map
